import { lazy, Suspense } from "react";

const WorkflowReport = lazy(() => import("../WorkflowReport"));

export function BuilderReportStage() {
  return (
    <section className="min-h-0 flex-1 overflow-auto p-5" aria-label="FDD Report">
      <h2 className="mb-4 text-base font-semibold">FDD Report</h2>
      <Suspense fallback={<p role="status">Loading report…</p>}>
        <WorkflowReport />
      </Suspense>
    </section>
  );
}
